/**
 * Created by PuTi(编程即菩提) 3/5/17.
 * nb.view.List
 */
module.exports = function (nb) {
    var opts = nb.opts;
    var $ = opts.$;
    var List = nb.define({
        view: {
            tag: 'ul'
        },
        method: {
            getListRoot: function () {
                return this.$();
            },
            onModelReady: function (inModel) {
                var self = this;
                var opts = this.getOpts();
                var mixRender = nb.opts.mixRender;
                inModel.onChange('items', function (inEvent) {
                    var self = this;
                    var $el = this.getListRoot();
                    var items = inEvent.data;
                    var itemType = opts ? opts.itemType : null;
                    var array = [];
                    var $itemList = this._$itemList = [];
                    var $children;

                    itemType = itemType ? itemType : inModel.get('itemType');

                    if (mixRender) {
                        $children = $el.children();
                    } else {
                        $el.empty();
                    }
                    $el.scrollTop(0);
                    $el.scrollLeft(0);
                    $.each(items, function (inIndex, inItem) {
                        var $child = $children ? $children.eq(inIndex) : null;
                        var type = inModel.getItemType ? (inModel.getItemType(inIndex, inItem) || itemType) : itemType;
                        var item = new type($el, $child);
                        var $item = item.$();
                        array.push(item);
                        if (!$children) {
                            $item.attr('data-list-index', inIndex);
                        }
                        item.setModel(inItem);
                        $itemList.push($item);
                        self.onItemReady(item);
                    });
                    this.onItemsReady(array);
                }, this, {before: true});
                inModel.onChange('appendItems', function (inEvent) {
                    var self = this;
                    var $el = this.getListRoot();
                    var items = inEvent.data;
                    var itemType = opts ? opts.itemType : null;
                    var array = [];
                    var $itemList = this._$itemList = this._$itemList || [];
                    var $children;
                    itemType = itemType ? itemType : inModel.get('itemType');
                    $.each(items, function (inIndex, inItem) {
                        var $child = $children ? $children.eq(inIndex) : null;
                        var type = inModel.getItemType ? (inModel.getItemType(inIndex, inItem) || itemType) : itemType;
                        var item = new type($el, $child);
                        var $item = item.$();
                        array.push(item);
                        if (!$children) {
                            $item.attr('data-list-index', inIndex);
                        }
                        item.setModel(inItem);
                        $itemList.push($item);
                        self.onItemReady(item);
                    });
                    this.onItemsReady(array);
                }, this, {before: true});
                inModel.onChange('activeIndex', function (inEvent) {
                    self.__onActiveIndexChange(inEvent);
                }, this);
            },
            __onActiveIndexChange: function (inEvent) {
                var lastIndex = inEvent.origin;
                var index = inEvent.data;
                var $el = this.$();
                var $itemList = this._$itemList;
                var activeCls = this.getModel().get('activeClass') || 'nb-v-active';
                if (lastIndex >= 0 && lastIndex < $itemList.length) {
                    $itemList[lastIndex].removeClass(activeCls);
                }
                if (index >= 0 && $itemList.length > 0) {
                    $itemList[index].addClass(activeCls);
                    $el.addClass(activeCls)
                } else {
                    $el.removeClass(activeCls)
                }
                this.onActiveIndexChanged(index, lastIndex)
            },
            get$ItemList: function () {
                return this._$itemList;
            },
            onActiveIndexChanged: function (inActiveIndex, inLastActiveIndex) {
            },
            onItemReady: function (inItem) {
            },
            onItemsReady: function (inItemList) {
            }
        }
    });
    nb.name('view.List', List, nb);
};


//////////////////
// WEBPACK FOOTER
// ../src/nb/core/js/core/view/list.js
// module id = 209
// module chunks = 35